// extracted by mini-css-extract-plugin
export default {"flex":"deviations_flex__U7C0t","header":"deviations_header__rx5Wb","search_wrapper":"deviations_search_wrapper__n8B9w"};